// Generated by CoffeeScript 2.7.0
import {
  ALIGN_REGEX
} from './assets.js';

export var getAlignStyle = function(dom) {
  var align, textAlign;
  if (!dom) {
    return null;
  }
  ({textAlign} = dom.style);
  align = dom.getAttribute('align') || textAlign || '';
  align = ALIGN_REGEX.test(align) ? align : null;
  return align;
};

export var generateAlignStyle = function(align) {
  if (align && align !== 'left') {
    return `text-align: ${align}`;
  } else {
    return '';
  }
};
